import { FC } from "react";

import {
  EmailIcon as Email,
  FacebookIcon as Facebook,
  InstagramIcon as Instagram,
  PinterestIcon as Pinterest,
  TiktokIcon as Tiktok,
  XIcon,
  YoutubeIcon as Youtube,
} from "../icons";

export interface SocialLinkItem {
  id: string;
  hrefAttr: string;
  Icon: FC<React.SVGProps<SVGSVGElement>>;
  analyticsRealEstate?: string;
  dataTestId?: string;
}

const BRAND_SOCIALS_MAP: Record<string, SocialLinkItem[]> = {
  veryireland: [
    {
      id: "Facebook",
      analyticsRealEstate: "-_-Footer-_-Facebook",
      hrefAttr: "https://www.facebook.com/veryireland",
      Icon: Facebook,
    },
    {
      id: "Instagram",
      analyticsRealEstate: "-_-Footer-_-Instagram",
      hrefAttr: "https://www.instagram.com/very.ireland",
      Icon: Instagram,
    },
    {
      id: "Pinterest",
      analyticsRealEstate: "-_-Footer-_-Pinterest",
      hrefAttr: "https://www.pinterest.com/veryireland",
      Icon: Pinterest,
    },
    {
      id: "X",
      analyticsRealEstate: "-_-Footer-_-X",
      hrefAttr: "https://x.com/Very_Ireland",
      Icon: XIcon,
    },
    {
      id: "Youtube",
      analyticsRealEstate: "-_-Footer-_-Youtube",
      hrefAttr: "https://www.youtube.com/c/veryireland",
      Icon: Youtube,
    },
    {
      id: "Tiktok",
      analyticsRealEstate: "-_-Footer-_-Tiktok",
      hrefAttr: "https://www.tiktok.com/@veryireland",
      Icon: Tiktok,
    },
    {
      id: "Email",
      analyticsRealEstate: "-_-Footer-_-Email",
      hrefAttr: "mailto:customerqueries@very.ie",
      Icon: Email,
    },
  ],

  littlewoods: [
    {
      id: "Facebook",
      analyticsRealEstate: "-_-Footer-_-Facebook",
      hrefAttr: "https://www.facebook.com/littlewoods",
      Icon: Facebook,
    },
    {
      id: "Instagram",
      analyticsRealEstate: "-_-Footer-_-Instagram",
      hrefAttr: "https://www.instagram.com/littlewoodsonline",
      Icon: Instagram,
    },
    {
      id: "Pinterest",
      analyticsRealEstate: "-_-Footer-_-Pinterest",
      hrefAttr: "https://www.pinterest.com/littlewoods",
      Icon: Pinterest,
    },
    {
      id: "X",
      analyticsRealEstate: "-_-Footer-_-X",
      hrefAttr: "https://x.com/littlewoods",
      Icon: XIcon,
    },
    {
      id: "Youtube",
      analyticsRealEstate: "-_-Footer-_-Youtube",
      hrefAttr: "https://www.youtube.com/user/littlewoodsonline",
      Icon: Youtube,
    },
  ],

  default: [
    {
      id: "Facebook",
      analyticsRealEstate: "-_-Footer-_-Facebook",
      hrefAttr: "https://www.facebook.com/VeryUK",
      Icon: Facebook,
    },
    {
      id: "Instagram",
      analyticsRealEstate: "-_-Footer-_-Instagram",
      hrefAttr: "https://instagram.com/veryuk",
      Icon: Instagram,
    },
    {
      id: "Pinterest",
      analyticsRealEstate: "-_-Footer-_-Pinterest",
      hrefAttr: "https://pinterest.com/veryhq",
      Icon: Pinterest,
    },
    {
      id: "X",
      analyticsRealEstate: "-_-Footer-_-X",
      hrefAttr: "https://x.com/verynetwork",
      Icon: XIcon,
    },
    {
      id: "Youtube",
      analyticsRealEstate: "-_-Footer-_-Youtube",
      hrefAttr: "https://www.youtube.com/user/verynetwork",
      Icon: Youtube,
    },
  ],
};

export const getBrandLinkList = (brand: string): SocialLinkItem[] =>
  BRAND_SOCIALS_MAP[brand] || BRAND_SOCIALS_MAP.default;
